var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.30469C13.0171 7.30469 14.6523 5.66948 14.6523 3.65234C14.6523 1.63521 13.0171 0 11 0C8.98287 0 7.34766 1.63521 7.34766 3.65234C7.34766 5.66948 8.98287 7.30469 11 7.30469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6837 7.79944C12.9104 8.30161 11.9887 8.59372 10.9999 8.59372C10.0112 8.59372 9.08944 8.30161 8.31613 7.79944C7.46127 8.12613 6.66867 8.60811 5.97949 9.22669L10.9999 11.1094L16.0203 9.22669C15.3312 8.60811 14.5386 8.12609 13.6837 7.79944Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7344 13.3203H18.3047C17.9487 13.3203 17.6602 13.6089 17.6602 13.9648V15.6836C17.6602 16.0395 17.9487 16.3281 18.3047 16.3281H18.7344C19.565 16.3281 20.2383 15.6548 20.2383 14.8242C20.2383 13.9936 19.565 13.3203 18.7344 13.3203Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75788 10.0665C3.58411 10.1869 3.48047 10.3848 3.48047 10.5962V12.0312H3.69531C4.7615 12.0312 5.62891 12.8986 5.62891 13.9648V15.6835C5.62891 16.7497 4.7615 17.6171 3.69531 17.6171H3.48047V18.9752C3.48047 19.2438 3.64714 19.4843 3.89868 19.5787L10.3555 21.9999V12.2443L4.35132 9.99275C4.15336 9.91846 3.9316 9.946 3.75788 10.0665Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3711 15.6835V13.9648C16.3711 12.8986 17.2385 12.0312 18.3047 12.0312H18.5195V10.5962C18.5195 10.3848 18.4159 10.1869 18.2421 10.0665C18.0684 9.946 17.8466 9.91846 17.6487 9.99275L11.6445 12.2443V21.9999L18.1013 19.5787C18.3529 19.4843 18.5195 19.2438 18.5195 18.9752V17.6171H18.3047C17.2385 17.6171 16.3711 16.7497 16.3711 15.6835Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 15.6836V13.9648C4.33984 13.6089 4.05127 13.3203 3.69531 13.3203H3.26562C2.43504 13.3203 1.76172 13.9936 1.76172 14.8242C1.76172 15.6548 2.43504 16.3281 3.26562 16.3281H3.69531C4.05127 16.3281 4.33984 16.0395 4.33984 15.6836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudent);
export default __webpack_public_path__ + "static/media/ic-student.7e3b671429e045b9a585ba4d29c84c87.svg";
export { ForwardRef as ReactComponent };